export const getSeoLinkUri = (slug: string[], isParameterUrl: boolean) => {
	if (isParameterUrl) {
		const filterIndex = slug.indexOf(`filter`)
		const newSlug = slug.slice(0, filterIndex)

		return `/catalog/${newSlug.join(`/`)}/`
	}

	return `/catalog/${slug.join(`/`)}/`
}
